import { array, object, string } from "yup";

export const addFilingSchema = object().shape({
  payment_schedule: string().required("required"),
  filing_period: array()
    .of(string())
    .when("payment_schedule", {
      is: (val: string) => val !== "SEMI_ANNUALLY" && val !== "ANNUALLY",
      then: (schema) =>
        schema.min(1, "Please select filing period").required("required"),
      otherwise: (schema) => schema.notRequired(),
    }),
  filing_season: string().required("Please select filing season"),
  state: string().required("Please select state"),
});
